import createStore from "@/utils/create-store";
import Model from "@/models/admin/managers";

export default createStore({ Model });
